<div class="flex w-full flex-col p-4">
  <div class="flex flex-row justify-between">
    <div class="flex flex-col justify-center">
      <div class="pl-2 text-xl">Test Video</div>
      <div class="flex flex-row justify-center">
        @if (!isVideo) {
          <button class="btn btn-primary btn-lg m-2 rounded-xl bg-green-400 p-2" (click)="startVideo()">
            Start Video/Audio
          </button>
        }
        @if (isVideo) {
          <button class="btn btn-primary btn-lg m-2 rounded-xl bg-green-400 p-2" (click)="stopVideo()">
            Stop Video/Audio
          </button>
        }
        @if (!isSamVideo) {
          <button class="btn btn-primary btn-lg m-2 rounded-xl bg-blue-400 p-2" (click)="startSamVideo()">
            Start SAM
          </button>
        }
        @if (isSamVideo) {
          <button class="btn btn-primary btn-lg m-2 rounded-xl bg-blue-400 p-2" (click)="stopSamVideo()">
            Stop SAM
          </button>
        }
        @if (!isAnimationFrame) {
          <button class="btn btn-primary btn-lg m-2 rounded-xl bg-violet-400 p-2" (click)="startAnimationFrame()">
            Start ANIMATION FRAME
          </button>
        }
        @if (isAnimationFrame) {
          <button class="btn btn-primary btn-lg m-2 rounded-xl bg-violet-400 p-2" (click)="stopAnimationFrame()">
            Stop ANIMATION FRAME
          </button>
        }
        @if (!isRecording) {
          <button class="btn btn-primary btn-lg m-2 rounded-xl bg-emerald-400 p-2" (click)="startRecording()">
            Start Recording
          </button>
        }
        @if (isRecording) {
          <button class="btn btn-warning btn-lg m-2 rounded-xl bg-emerald-400 p-2" (click)="stopRecording()">
            Stop Recording
          </button>
        }

        @if (!haveWebGLCanvas) {
          <button class="btn btn-warning btn-lg m-2 rounded-xl bg-blue-200 p-2" (click)="addWebGLCanvas()">
            Add WebGL Canvas
          </button>
        }
        @if (haveWebGLCanvas) {
          <button class="btn btn-warning btn-lg m-2 rounded-xl bg-blue-200 p-2" (click)="removeWebGLCanvas()">
            Remove WebGL Canvas
          </button>
        }
        @if (!haveSampleCanvas) {
          <button class="btn btn-warning btn-lg m-2 rounded-xl bg-blue-100 p-2" (click)="addSampleCanvas()">
            Add Sample Canvas
          </button>
        }
        @if (haveSampleCanvas) {
          <button class="btn btn-warning btn-lg m-2 rounded-xl bg-blue-100 p-2" (click)="removeSampleCanvas()">
            Remove Play Canvas
          </button>
        }
        <button class="btn btn-warning btn-lg m-2 rounded-xl bg-red-400 p-2" (click)="reset()">Reset</button>
      </div>
      <div class="flex flex-row justify-between gap-2">
        <app-select-camera-input-button (selection)="updateDeviceId($event)" />
        <div class="flex flex-col gap-2">
          <div class="mt-2 flex items-center gap-2">
            <span>Canvas Refresh Rate</span>
            <input type="range" [value]="" min="50" max="500" step="50" (input)="update($event)" class="w-24" />
            <span>{{ 0 }}</span>
          </div>
          <div class="mt-2 flex items-center gap-2">
            <span>Fabric Canvas Refresh Rate</span>
            <input type="range" [value]="" min="50" max="500" step="50" (input)="update($event)" class="w-24" />
            <span>{{ 0 }}</span>
          </div>
        </div>
        <div class="bg-black flex flex-col gap-1 rounded bg-opacity-50 px-2 py-1">
          <div>{{ this.canvasRefreshFps }} FPS Canvas Refresh</div>
          <div>{{ this.fabricCanvasRefreshFps }} FPS Fabric Canvas Refresh</div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-between pt-10">
    <div class="flex flex-row rounded-lg border-2">
      <div class="m-4 flex flex-col text-center">
        <h1>Raw Video Stream</h1>
        <video width="640" height="360" class="video" #videoInput autoplay controls></video>
      </div>
    </div>
    <div class="flex flex-row rounded-lg border-2">
      <div class="m-4 flex flex-col text-center">
        <h1>Video Recording</h1>
        <video width="640" height="360" class="video" style="width: 360 !important" controls #recordedVideo></video>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-between pt-10">
    <div class="flex flex-row rounded-lg border-2">
      <div class="m-4 flex flex-col text-center">
        <h1>WebGL Canvas</h1>
        <canvas #webGLCanvas width="640" height="360" class=""></canvas>
      </div>
    </div>
    <div class="flex flex-row rounded-lg border-2">
      <div class="m-4 flex flex-col text-center">
        <h1>Sample Canvas</h1>
        <canvas #sampleCanvas width="640" height="360" class=""></canvas>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-between pt-10">
    <div class="flex flex-row rounded-lg border-2">
      <div class="m-4 flex flex-col text-center">
        <h1>Sams Video</h1>
        <video width="640" height="360" class="video" #testVideoInputSam autoplay controls></video>
      </div>
    </div>
    <div class="flex flex-row rounded-lg border-2">
      <div class="m-4 flex flex-col text-center">
        <h1>Backgrounds</h1>
        <img
          style="height: 10rem"
          src="https://plus.unsplash.com/premium_photo-1668708034541-4ba9a33fae3a?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          crossorigin="anonymous"
          id="background3"
          (click)="changeBackground(3)"
        />
        <img
          style="height: 10rem"
          src="https://images.unsplash.com/photo-1648554586178-bbd078dd26b4?q=80&w=2675&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          crossorigin="anonymous"
          id="background2"
          (click)="changeBackground(2)"
        />
      </div>
    </div>
  </div>
</div>
